import { useParams, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import "../styles/archives.css";

export default function ArchiveTemplate() {
  const { id } = useParams();
  const machineName = id.toLowerCase();

  const [text, setText] = useState("");

  useEffect(() => {
    fetch(`/machines/${machineName}/${machineName}2.txt`, { cache: "no-store" })
      .then((res) => res.text())
      .then((data) => setText(data))
      .catch(() =>
        setText("Aucune archive texte disponible pour cette machine.")
      );
  }, [machineName]);

  return (
    <div className="maquette-container">
      {/* Bouton retour maquette */}
      <div style={{ textAlign: "right", marginBottom: "16px" }}>
        <Link to={`/machines/${id}/maquette`} className="steampunk-button">
          Voir la maquette
        </Link>
      </div>

      {/* Plaque */}
      <div className="archive-image">
        <img
          src={`/machines/${machineName}/plaque_${machineName}.jpg`}
          alt={`Plaque ${id}`}
          style={{ maxWidth: "400px", width: "100%", height: "auto" }}
        />
      </div>

      {/* Vidéo */}
      <div className="archive-video">
        <video
          controls
          autoPlay
          muted
          loop
          playsInline
          style={{ maxWidth: "100%", margin: "20px 0" }}
        >
          <source
            src={`/machines/${machineName}/${machineName}_old.mp4`}
            type="video/mp4"
          />
          Votre navigateur ne supporte pas la vidéo.
        </video>
      </div>

      {/* Images */}
      <div className="archive-images">
        <img
          src={`/machines/${machineName}/${machineName}_old1.png`}
          alt={`${id} archive 1`}
          style={{ maxWidth: "100%", marginBottom: "16px" }}
        />
        <img
          src={`/machines/${machineName}/${machineName}_old2.png`}
          alt={`${id} archive 2`}
          style={{ maxWidth: "100%", marginBottom: "16px" }}
        />
      </div>

      {/* Texte */}
      <div className="archive-texte">
        <p style={{ whiteSpace: "pre-line" }}>{text}</p>
      </div>
    </div>
  );
}
